import { invariant } from "@/utils/invariant";
import { useParams } from "react-router";

export function useCampaignId() {
  const { id } = useParams<{ id: string }>();

  invariant(id != null, "Campaign ID is required");

  return id;
}
